import { Component, OnInit, Inject } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { OpdDocsStatusComponent } from '../../opd/opd-docs-status/opd-docs-status.component';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-follow-dnp-modal',
  templateUrl: './follow-dnp-modal.component.html',
  styleUrls: ['./follow-dnp-modal.component.css']
})
export class FollowDnpModalComponent implements OnInit {
  modalForm: FormGroup;loading:boolean=false;submitted:boolean=false;modalData:any;
  treatments=[];minDate = new Date();
  constructor(private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder,public dialogRef: MatDialogRef<FollowDnpModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog) {
    if(data){
      this.modalData = data;
      console.log(this.modalData);
      this.modalForm = this.formBuilder.group({
        'dnp_followup_date' : [null, Validators.required],
        'comments' : [this.modalData.currentData.data.description, Validators.required],
        'pagetype':[this.modalData.pagetype],
        'type':[this.modalData.type],
        'lead_id':[this.modalData.leadId],
        'payment_mode':[null, Validators.required],
        'treatment': [null, Validators.required],
        'fieldName':[this.modalData.fieldName],
        'old_status':[this.modalData.old_status]
      });

      if(this.modalData.currentData.data.display_followup == 0) {
        this.modalForm.controls['dnp_followup_date'].setValidators(null);
        this.modalForm.controls['dnp_followup_date'].updateValueAndValidity();
      }

      if(this.modalData.currentData.data.paymentMode == 1 || this.modalData.pagetype == 1) {
        this.modalForm.controls['payment_mode'].setValidators(null);
        this.modalForm.controls['payment_mode'].updateValueAndValidity();
      }

      if(this.modalData.currentData.data.treatment == 1 || this.modalData.pagetype == 1) {
        this.modalForm.controls['treatment'].setValidators(null);
        this.modalForm.controls['treatment'].updateValueAndValidity();
      }

      if(this.modalData.pagetype == 3) {
        this.modalForm.controls['comments'].setValidators(null);
        this.modalForm.controls['comments'].updateValueAndValidity();
      }
    }
  }

  ngOnInit(): void {
    this.getTreatment();
  }
  get f() { return this.modalForm.controls; }

  CloseModal(): void {
    this.dialogRef.close({event:'Cancel'});
  }

  SaveData(){
      this.submitted = true;
      this.loading = true;
        // stop here if form is invalid
        if (this.modalForm.invalid) {
            this.loading = false;
            return;
        }
      this.leadapi.addDnpFollowUpData(this.modalForm.value)
      .subscribe((data:any) => {
      this.submitted = false;
      this.loading = false;
      if(data.status)
      {
          this.sharedapi.presentToast(data.msg);
          this.dialogRef.close();

      }
      else
      {
          this.sharedapi.presentToast(data.msg);
      }
      }, error =>
      {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

}
